import {
  clearTokens,
  getPushNotificationToken,
  useApolloClient,
  useDetachDeviceFromUserMutation,
} from "@stepapp/core";
import { useRouter } from "expo-router";
import { useCallback } from "react";
import { useAppDispatch } from "../../hooks/redux";
import { AppStorage } from "../../services/AppStorage";
import { logoutIntercom } from "../../services/Intercom";
import { resetStore } from "../../store/extraReducers";

export const useLogout = () => {
  const { replace } = useRouter();
  const client = useApolloClient();
  const appDispatch = useAppDispatch();
  const [detachDeviceFromUser] = useDetachDeviceFromUserMutation();

  const handleLogOut = useCallback(async () => {
    const detachDevice = async () => {
      const expoToken = await getPushNotificationToken();

      if (expoToken) {
        await detachDeviceFromUser({ variables: { data: { deviceToken: expoToken } } });
      }
    };

    await detachDevice();
    clearTokens({ AppStorage });
    logoutIntercom();
    appDispatch(resetStore());
    client.resetStore();

    replace("/");
  }, [appDispatch, replace, detachDeviceFromUser, client]);

  return handleLogOut;
};
